import React from 'react';
import { LOCALES, setLocale } from '../i18n';

// Simple EN/VI toggle — persists via i18n.js's localStorage-backed setLocale.
// Kept independent from trustflow_web's locale (no shared cookie for it
// today, unlike the SSO auth_token cookie) but uses the same 'vi'/'en' codes.
export default function LanguageSwitcher({ current, variant }) {
  return (
    <div className={`lang-switcher ${variant === "light" ? "lang-switcher-light" : ""}`} role="group" aria-label="Language">
      {LOCALES.map((code) => (
        <button
          key={code}
          type="button"
          className={`lang-btn ${current === code ? 'lang-btn-active' : ''}`}
          onClick={() => setLocale(code)}
        >
          {code.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
